<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Whitelisting" title="View Whitelisting Request" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

                            <div class="col-md-12 filter-sort">
								<div class="row">

									<div class="col-md-6 d-flex" style="margin-top: 32px;">
										<label class="d-flex listing-length"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchWhitelistRequest()">
												<option value="20">20</option>
												<option value="30">30</option>
												<option value="50">50</option>
												<option value="100">100</option>
												<option value="200">200</option>
											</select>
											<span>entries</span>
										</label>
									</div>

                                    <div class="col-md-2">
										<label class="control-label">Type<span class="text-danger">*</span></label>
										<select class="form-select" v-model="type" @change="fetchWhitelistRequest()">
                                            <option value="">Select Type</option>
                                            <option value="1">SMS</option>
                                            <option value="2">Data</option>
                                        </select>
									</div>

									<div class="col-md-2">
										<label class="control-label">Network Profile</label>
										<select class="form-select" v-model="profile" @change="fetchWhitelistRequest()">
											<option value="">All</option>
											<option value="1">AIRTEL+BSNL</option>
											<option value="2">Vodafone+BSNL</option>
											<option value="3">AIRTEL+Vodafone</option>
										</select>
									</div>

                                    <div class="col-md-2 float-end" style="margin-top: 32px;">
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchWhitelistRequest()"/>
									</div>
								</div>
							</div>
		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Create Date</th>
											<th>Company Name</th>
											<th>Type</th>
											<th>Customer Id</th>
											<th>Request ID</th>
											<th>Status</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody v-if="Boolean(requests.length)">
										<tr v-for="(request, index) in requests" :key="request.id" align="center">
                                            <td>{{ index + 1}}</td>
											<td>{{ request.request_date }}</td>
                                            <td>{{ request.company_name }}</td>
											<td>
												<span v-if="request.type == 1">SMS</span>
												<span v-else>Data</span>
											</td>
											<td>{{ request.customer_id }}</td>
											<td>
												<span class="clickable-text" @click="downloadFile(request)">
													{{ request.request_id }}
												</span>
											</td>
                                            <td>
                                                <span class="badge rounded-pill bg-warning" v-if="request.status==0">Pending</span>
                                 		        <span class="badge rounded-pill bg-info" v-if="request.status==1">Ongoing</span>
                                                <span class="badge rounded-pill bg-success" v-if="request.status==2">Approved</span>
                                                <span class="badge rounded-pill bg-danger" v-if="request.status==3">Rejected</span>
                                            </td>
                                            <td>
                                                <div v-if="request.status==0" class="example-popover" data-container="body" data-bs-toggle="tooltip" data-bs-placement="top" title="Upload Excel" @click="openModal(request.id)">
                                                    <i class="icofont icofont-upload-alt"></i>
                                                </div>
                                            </td>
                                        </tr>	
									</tbody>

									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchWhitelistRequest(page.url + '&type=' + type + '&profile=' + profile +  '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="uploadExcel" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file"  @change="setFile($event)" accept=".csv" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import {
    Tooltip
} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {
	      
			return {
				
				pagination: {},
				keyword: "",
				listing_length: 20,
				token: "",
				i: 1,				

				modal_title: "Upload Excel",
				button_title: "Upload",

                type: "",
                profile: "",

                requests: [],
				selected_request_id:null,
				file:"",
				Preview_image:"",

			};
		},
		mounted() {
            new Tooltip(document.body, {
                    selector: "[data-bs-toggle='tooltip']",
                })
        },
        unmounted() {

            let popovers = document.getElementsByClassName('tooltip')
            // popovers.forEach(item => {
            //     item.remove()
            // })

        },

		created() {
			this.fetchWhitelistRequest();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchWhitelistRequest(page_url = null) {
				this.getToken();
				let url = "/trazio/whitelistRequest?limit=" + this.listing_length + "&keyword=" + this.keyword + "&type=" + this.type + "&profile=" + this.profile;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.requests = responseData.whitelistRequest.data;
						this.pagination = responseData.whitelistRequest.links;
						this.from = responseData.whitelistRequest.from;
						this.to = responseData.whitelistRequest.to;
						this.total = responseData.whitelistRequest.total;
						console.log(responseData);
					})
					.catch((err) => console.log(err));
			},

			setFile(e) {
				this.file = e.target.files[0];
				this.Preview_image = URL.createObjectURL(e.target.files[0]);
				
			},

			uploadExcel() {
				this.getToken();

				const config = {
					headers: {
					"Content-type": "multipart/form-data",
					Accept: "application/json",
					Authorization: "Bearer " + this.token,
					},
				};

				let url = "trazio/updateWhitelistRequest";
				{
					{
					this.token;
					}
				}
				let formData = new FormData();
				formData.append("file", this.file);
				formData.append("id", this.selected_request_id); 

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchWhitelistRequest();
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.status == 422) {
								if (error.response.data) {
									this.errors = error.response.data.message;
								}
								this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					});
			},

			downloadFile(request) 
			{
				this.getToken();
				let page_url = "trazio/downloadWhitelistFile?request_id=" + request.id;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Whitelist_" + request.request_id + ".csv";

					link.click();
						
				})
				.catch((err) => console.log(err));
			},

			openModal(id) {
				this.selected_request_id = id;
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

		},
	};
</script>
